import { FormLabel } from './form-label'
import type { AnyFieldApi } from '@tanstack/react-form'
import { Textarea } from '@/components/ui/textarea'

export interface FormTextareaProps extends React.ComponentProps<
  typeof Textarea
> {
  field: AnyFieldApi
  label?: string
  helper?: React.ReactNode
}

export function FormTextarea({
  field,
  label,
  helper,
  ...props
}: FormTextareaProps) {
  return (
    <div className="gap-0">
      {label && (
        <FormLabel htmlFor={props.name} required={props.required}>
          {label}
        </FormLabel>
      )}
      <Textarea
        {...props}
        value={field.state.value || ''}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={field.handleBlur}
      />
      {helper ? (
        <p className="text-xs text-neutral-500 mt-1">{helper}</p>
      ) : null}
      {field.state.meta.isTouched && !field.state.meta.isValid ? (
        <p className="text-xs text-red-500">
          {field.state.meta.errors.join(', ')}
        </p>
      ) : null}
      <p className="text-xs">
        {field.state.meta.isValidating ? 'Validating...' : null}
      </p>
    </div>
  )
}
